<div class="task-list">
  @let groupByDeal = groupByDeal$ | async;

  <div class="task-list__header">
    <div class="task-list__group-toggle">
      <mat-slide-toggle
        color="accent"
        [checked]="groupByDeal ?? false"
        (change)="onGroupByDealToggle($event.checked)">
        {{ 'GNR_GROUP_BY_DEAL' | translate }}
      </mat-slide-toggle>
    </div>
    <button
      class="task-list__add-button"
      (click)="openTaskDialog()"
      matTooltip="{{ 'GNR_ADD_TASK' | translate }}"
      type="button">
      <mat-icon>add</mat-icon>
    </button>
  </div>

  @let rows = displayedTasks$ | async;

  <div class="task-list__content">
    @if (rows?.length || isLoading()) {
      <qt-data-table
        class="task-list__table"
        [columns]="taskTableColumns"
        [data]="rows"
        [tableConfig]="dataTableConfig"
        [loading]="isLoading()"
        [rowStylesCallback]="rowStylesCallback"
        (rowClick)="onRowClick($event)"
        [rowTrackByFn]="trackByRow">
        <ng-template qtColumnDef="title" let-row="row">
          @if (row.kind === 'group') {
            <div
              class="task-list__group-row"
              [matTooltip]="row.label"
              matTooltipShowDelay="300">
              <span class="task-list__group-row__text">{{ row.label }}</span>
            </div>
          } @else {
            <div
              class="task-list__title-cell"
              [class.task-list__title-cell--disabled]="row.expired">
              <div class="task-list__title-text">
                {{ row.title }}
              </div>
              @if (row.dealName && !groupByDeal) {
                <div
                  class="task-list__deal-chip"
                  [matTooltip]="row.dealName"
                  matTooltipShowDelay="100">
                  {{ row.dealName }}
                </div>
              }
            </div>
          }
        </ng-template>

        <ng-template qtColumnDef="dueDate" let-row="row">
          @if (row.kind === 'task') {
            <div
              class="task-list__due-date"
              [class.task-list__due-date--expired]="row.expired">
              <mat-icon>calendar_month</mat-icon>
              <span>
                {{
                  row.dueDate
                    ? (row.dueDate | date: 'MMM d, y')
                    : ('GNR_NO_DUE_DATE' | translate)
                }}
              </span>
            </div>
          }
        </ng-template>

        <ng-template qtColumnDef="status" let-row="row">
          @if (row.kind === 'task') {
            <qt-task-table-status
              [task]="row.task"
              [status]="getStatusValue(row)"
              (statusChange)="onTaskStatusChange($event, row)">
            </qt-task-table-status>
          }
        </ng-template>
      </qt-data-table>
    } @else {
      <div class="task-list__empty-state">
        <p class="task-list__empty-message">{{ 'GNR_NO_TASKS' | translate }}</p>
      </div>
    }
  </div>
</div>
